export default "__VITE_ASSET__bd99a27e__"